<template>
 <div class="company-info__group">
   <div class="employer-profile-media">
      <div class="company-info__group-title">{{$tEmployer('Media gallery')}}</div>
      <div class="employer-profile-media__inner">

        <div class="employer-profile-media__content">
            <div class="employer-profile-media__carousel-inner">
              <div class="employer-profile-media__carousel">
                <div ref="profile-media"
                     class="employer-profile-media__carousel-wrap"
                    :class="{_images:images.length}">
                  <div class="employer-profile-media__list">
                    <div class="employer-profile-media__slide"
                         v-for="(item, index) in images"
                         :key="index">
                      <video v-if="isVideo(item)"
                             controls
                             class="employer-profile-media__slide-img">
                        <source :src="item.path" :type="'video/'+item.ext">
                        Your browser does not support the video tag.
                      </video>
                      <img v-else
                           :src="item.path"
                           alt="image"
                           class="employer-profile-media__slide-img">
                    </div>
                  </div>
                </div>
                <button ref="prev" class="employer-profile-media__nav  _prev  base-btn  base-btn--grey-blue">
                  <BaseSvg name="ico-arrow-light"/>
                </button>
                <button ref="next" class="employer-profile-media__nav  _next  base-btn  base-btn--grey-blue">
                  <BaseSvg name="ico-arrow-light"/>
                </button>
                <div class="employer-profile-media__add ">
                  <input type="file"
                         @input="onFilesInputMixin">

                  <span class="employer-profile-media__add-btn"
                        :class="{_images:images.length}">
                    <BaseSvg name="ico-plus" width="2rem" height="2rem"/>
                    <span class="add-company-logo__label d-none d-sm-inline-flex">{{$tEmployer('Add')}}</span>
                  </span>

                </div>
                <button v-if="images.length"
                        type="button"
                        @click.prevent="onDeleteFile()"
                        class="employer-profile-media__btn-remove base-btn">
                  <BaseSvg name="ico-close"/>
                </button>
              </div>
              <div class="company-info__gallery-comment">
                <BaseSvg name="ico-info"/>
                <span class="text">{{$tEmployer('media_comment')}}</span>
              </div>
            </div>

            <div v-if="images.length"
                 class="employer-profile-media__description-wrap _images">
              <div v-for="(item, index) in images"
                   :key="index"
                   v-show="index === activeSlide"
                   class="employer-profile-media__description">
                <div class="employer-profile-media__description-top">
                  <BaseSelect :label="$tNewVacancy('Gallery position')"
                              :value="index + 1"
                              :options="positions"
                              @input="onChangePosition(index, item, $event - 1)"
                              class="employer-profile-media__position-select _white _shadow-full"
                  />
                </div>
                <TranslateFiled
                  :label="$tNewVacancy('Comment')"
                  textarea
                  :value="item.comment"
                  @input="onCommentInput(index, $event)"
                  class="employer-profile-media__comment"
                />
                <button @click.prevent="onSaveComment(item)"
                        class="base-btn base-btn--outline-grey base-btn--small employer-profile-media__save-comment">
                  <span class="base-btn__text">{{$tNewVacancy('Save')}}</span>
                </button>

                <BaseAlert v-if="commentAlert"
                           :value="$tEmployer('Comment was successfully saved')"
                           class="employer-profile-media__alert  _success"/>
              </div>
            </div>
            <div v-else
                 class="employer-profile-media__description-wrap _disabled">

              <div class="employer-profile-media__description">
                <div class="employer-profile-media__description-top">
                  <BaseSelect :label="$tNewVacancy('Gallery position')"
                              :value="positions[0]"
                              :options="positions"
                              class="employer-profile-media__position-select _white _shadow-full"/>
                </div>
              </div>
              <TranslateFiled
                :label="$tNewVacancy('Comment')"
                textarea
                :value="null"
                disabled
                class="employer-profile-media__comment"
              />
            </div>
          </div>

      </div>
  </div>


  </div>
</template>

<script>
  import { http } from '../axios';
  import Swiper from "swiper";
  import TranslateFiled from './TranslateFiled'
  import fileUploadMixin from '../mixins/fileUploadMixin'
  import {
    VIDEOS_MIME_TYPES,
    IMAGES_MIME_TYPES,
    ALLOWED_IMAGES_EXTS,
    ALLOWED_VIDEOS_EXTS
  } from '../constants/files'

  export default {
    name: "EmployerProfileMedia",
    mixins: [fileUploadMixin],
    props: {
      employer: {
        type: Object
      }
    },
    components: {
      TranslateFiled
    },
    data() {
      return {
        filesToUpload: [],
        filesUploaded: [],
        swiper: null,
        activeSlide: 0,
        dragoverMixin: false,
        errorMixin: null,
        uploadFileMethodNameMixin: ['uploadFile'],
        allowedFilesExtsMixin: [...ALLOWED_IMAGES_EXTS, ...ALLOWED_VIDEOS_EXTS],
        allowedFilesMimeTypes: [...IMAGES_MIME_TYPES, ...VIDEOS_MIME_TYPES],
        currentSlide: null,
        commentAlert: false
      }
    },
    computed: {
      images() {
        return this.filesUploaded.slice().reverse() || this.filesToUpload
      },
      positions() {
        const positions = []
        for (let i = 0; i < this.images.length; i++) {
          positions.push(i + 1)
        }
        return positions
      },
      employerId() {
        return this.employer.id
      },
      slidesCount() {
        return this.filesUploaded.length
      }
    },
    methods: {
      isVideo(file) {
        return ['mp4', 'webm'].includes(file.ext)
      },
      loadGallery() {
        if(!this.employerId) return;

        return http.get(`/api/cabinet/employer-profile/${this.employerId}/files`).then(({ data }) => {
          this.filesUploaded = data.data

          for (let i = 0; i < this.filesUploaded.length; i++) {
            const item = this.filesUploaded[i]
            this.$set(this.filesUploaded[i], 'comment', JSON.stringify(item.comment_translations))
           /* this.$set(this.filesUploaded[i], 'position', i)*/
          }
      })

      /*  return http.get(`/api/cabinet/employer-profile/${this.employerId}/files`)
          .then(({ data }) => {
            if(data.data.length) {
              this.filesUploaded = data.data
            }

          })*/
      },
      createSwiper() {
        this.swiper = new Swiper(this.$refs['profile-media'], {
          wrapperClass: 'employer-profile-media__list',
          slideClass: 'employer-profile-media__slide',
          slidesPerView: 'auto',
          watchOverflow: true,
          roundLengths: true,
          observer: true,
          navigation: {
            prevEl: this.$refs['prev'],
            nextEl: this.$refs['next'],
            disabledClass: '_disabled',
            hiddenClass: '_hidden',
            lockClass: '_hidden'
          }
        })
      },
      checkActiveSlide() {
        this.activeSlide = this.swiper.activeIndex
        this.currentSlide = this.images[this.activeSlide]
      },

      uploadFile(files) {
        let file = files[0];

        const sendData = new FormData()
        sendData.append('file', file)

        return http.post(`/api/cabinet/employer-profile/${this.employerId}/file`, sendData).then((data) => {
          let uploadedFile = data.data.data;
          let ind = this.slidesCount;
          this.setPosition(uploadedFile, ind)
        }).finally(()=>{
          this.loadGallery()
        })
      },
      onDeleteFile() {
        let id = this.currentSlide !==null ? this.currentSlide.id : this.images[0].id;
        return http.delete(`/api/cabinet/employer-profile/${this.employerId}/file/${id}`).then(() => {
        }).finally(()=>{
          this.loadGallery()
        })
      },

      onCommentInput(index, comment) {
        this.$set(this.images[index], 'comment', comment)
      },

      onChangePosition(index, item, position) {
        if (isNaN(position)) return
        const File = this.images.splice(index, 1)[0]
        item.position = position

        this.images.splice(position, 0, File)
        const sendData = {
          file_id: item.id,
          comment: item.comment,
          position: position
        }

        return  http.patch(`/api/cabinet/employer-profile/${this.employerId}/file/${item.id}`, sendData).then(() => {
        }).finally(()=>{
            this.loadGallery()
            this.swiper.slideTo(position, 600);
        })
      },
      setPosition(file, position) {
        const sendData = {
          file_id: file.id,
          // comment: file.comment,
          position: position
        }
        return  http.patch(`/api/cabinet/employer-profile/${this.employerId}/file/${file.id}`, sendData).then(() => {
        }).finally(()=>{
          this.swiper.slideTo(position, 600)
        this.loadGallery()
        })
      },

      onSaveComment(item) {
        const sendData = {
          file_id: item.id,
          comment: item.comment,
          position: item.position
        }
        return http.patch(`/api/cabinet/employer-profile/${this.employerId}/file/${item.id}`, sendData).then(() => {
          this.commentAlert = true
          setTimeout(()=>{this.commentAlert = false}, 3000)
        }).finally(()=>{})
      }
    },
    created() {
      this.loadGallery()
    },
    mounted() {
      this.createSwiper()
      this.swiper.on('init slideChange', this.checkActiveSlide)
    },
    beforeDestroy() {
      if (this.swiper) {
        this.swiper.destroy();
      }
    }
  }
</script>

<style>

</style>
